import { QuestionStep } from '../QuestionStep';
import { MultiChip } from './_shared';
import {
  FOOTER_OPTIONS,
  STEPS,
  type QuestionnaireAnswers,
} from '../questions';

interface FooterStepProps {
  answers: QuestionnaireAnswers;
  onChange: (next: Partial<QuestionnaireAnswers>) => void;
}

export function FooterStep({ answers, onChange }: FooterStepProps) {
  const step = STEPS.find((s) => s.id === 'footer')!;
  return (
    <QuestionStep step={step}>
      <MultiChip
        options={FOOTER_OPTIONS}
        values={answers.footer_items ?? []}
        onChange={(v) => onChange({ footer_items: v })}
      />
      <p className="mt-6 font-mono text-[11px] text-graphite leading-relaxed">
        <span className="text-ochre">¶</span>&nbsp;&nbsp;Pick anything that should appear at the bottom. AURA groups these into footer columns automatically.
      </p>
    </QuestionStep>
  );
}
